import React from "react"

export type PropertyStatItem = {
   count?: number | null
   label: string
   icon: React.ReactNode
   valueClassName?: string
}

interface PropertyStatsProps {
   stats: PropertyStatItem[]
}

function PropertyStats({stats}: PropertyStatsProps) {
   const visibleStats = stats.filter(stat => (stat.count ?? 0) > 0)

   if (visibleStats.length === 0) return null

   return (
      <div className="flex items-center gap-2">
         {visibleStats.map(stat => (
            <React.Fragment key={stat.label}>
               {stat.icon}
               <p className={stat.valueClassName}>
                  {stat.count} <span className="text-xs uppercase text-gray-500">{stat.label}</span>
               </p>
            </React.Fragment>
         ))}
      </div>
   )
}

export default PropertyStats
